module.exports = __webpack_public_path__ + "img/project4.ff4e09ea.png";